import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Controller, useFormContext } from 'react-hook-form';

import { fc } from 'i18n';
import { IDraftForm } from 'types/tep';
import { actions } from 'core/redux/api/veta/tep/companies';
import { isTepCompaniesLoadingSelector, tepCompaniesSelector } from 'core/redux/selectors/tep';
import { SelectPickerWithCreate } from 'components/molecules/select-picker-with-create';

import styles from './styles.module.css';

interface ICompanyProps {
  rowIndex: number;
}

export const Company: FC<ICompanyProps> = ({ rowIndex }) => {
  const dispatch = useDispatch();

  const companies = useSelector(tepCompaniesSelector);
  const isLoading = useSelector(isTepCompaniesLoadingSelector);

  const { formState, control } = useFormContext<IDraftForm>();

  const { errors } = formState;

  const error = errors.leases?.[rowIndex]?.company?.message;

  const options = companies.map(({ id, name }) => ({ label: name, value: id }));

  const addCompany = (name: string) => () => {
    dispatch(actions.add.request({ name }));
  };

  return (
    <Controller
      control={control}
      name={`leases.${rowIndex}.company`}
      rules={{ required: fc('please enter company name') }}
      defaultValue={null}
      render={({ value, onChange }) => (
        <div className={styles.company}>
          <SelectPickerWithCreate
            isLoading={isLoading}
            mainPlaceholder="enter company name"
            addPlaceholder={fc('enter new company name')}
            selected={value}
            onChange={onChange}
            onAdd={addCompany}
            options={options}
            withSearch
          />
          {/*TODO: error messages should be moved to corresponding form components when they are being refactored*/}
          {!!error && <div className={styles.error}>{error}</div>}
        </div>
      )}
    />
  );
};
